import gql from "graphql-tag";
/**
 * todo move this to an admin interface
 * type Mutation {
 *  registerAsset(assetId: String!, ticker: String!, base64Logo: String, decimals: Int = 6): Query
 * }
 */
export var Coin;
(function (Coin) {
    Coin["CoinA"] = "CoinA";
    Coin["CoinB"] = "CoinB";
})(Coin || (Coin = {}));
export var FreezerStatus;
(function (FreezerStatus) {
    /** No rewards have matured yet */
    FreezerStatus["Allocating"] = "Allocating";
    /** Rewards have matured and can be harvested */
    FreezerStatus["Harvested"] = "Harvested";
    FreezerStatus["Immature"] = "Immature";
    /** Rewards are mature, but still being allocated, so are unable to be harvested */
    FreezerStatus["Mature"] = "Mature";
})(FreezerStatus || (FreezerStatus = {}));
export var OpType;
(function (OpType) {
    OpType["CreatePool"] = "CreatePool";
    OpType["DepositMixed"] = "DepositMixed";
    OpType["DepositSingle"] = "DepositSingle";
    OpType["Swap"] = "Swap";
    OpType["Withdraw"] = "Withdraw";
})(OpType || (OpType = {}));
export var Rank;
(function (Rank) {
    Rank["RankTvl"] = "RankTVL";
})(Rank || (Rank = {}));
export var Resolution;
(function (Resolution) {
    Resolution["Canceled"] = "Canceled";
    Resolution["Harvested"] = "Harvested";
    Resolution["Scooped"] = "Scooped";
})(Resolution || (Resolution = {}));
export var TokenMetadataSource;
(function (TokenMetadataSource) {
    TokenMetadataSource["CardanoTokenRegistry"] = "CardanoTokenRegistry";
    TokenMetadataSource["OnChainLabel20"] = "OnChainLabel20";
    TokenMetadataSource["OnChainLabel721"] = "OnChainLabel721";
})(TokenMetadataSource || (TokenMetadataSource = {}));
export var VolumeInterval;
(function (VolumeInterval) {
    VolumeInterval["Daily"] = "Daily";
    VolumeInterval["Monthly"] = "Monthly";
    VolumeInterval["Weekly"] = "Weekly";
})(VolumeInterval || (VolumeInterval = {}));
export var YieldTerm;
(function (YieldTerm) {
    YieldTerm["Term30"] = "Term30";
})(YieldTerm || (YieldTerm = {}));
export const OpFragmentFragmentDoc = gql `
  fragment OpFragment on Op {
    __typename
    ... on OpSwap {
      swapGot: got
      swapQuantityA: quantityA
      swapQuantityB: quantityB
      swapWant: want
    }
    ... on OpDepositMixed {
      depositMixedLq: lq
      depositMixedQuantityA: quantityA
      depositMixedQuantityB: quantityB
    }
    ... on OpDepositSingle {
      depositSingleLq: lq
      depositSingleQuantityA: quantityA
      depositSingleQuantityB: quantityB
    }
    ... on OpWithdraw {
      withdrawLq: lq
      withdrawQuanittiyA: quantityA
      withdrawQuanittiyB: quantityB
    }
  }
`;
export const AssetFragmentFragmentDoc = gql `
  fragment AssetFragment on Asset {
    assetId
    policyId
    assetName
    decimals
    logo
    ticker
    dateListed
    sources
  }
`;
export const PoolFragmentFragmentDoc = gql `
  fragment PoolFragment on Pool {
    apr
    rewards {
      apr
      asset {
        ...AssetFragment
      }
    }
    assetA {
      ...AssetFragment
    }
    assetB {
      ...AssetFragment
    }
    assetLP {
      ...AssetFragment
    }
    fee
    quantityA
    quantityB
    quantityLP
    ident
    assetID
  }
`;
export const OperationFragmentFragmentDoc = gql `
  fragment OperationFragment on Operation {
    createdAt {
      format(layout: "2006-01-02T15:04:05-0700")
    }
    op {
      __typename
      ...OpFragment
    }
    outcome {
      feeA
      feeB
      quantityA
      quantityB
      quantityLP
      price {
        unit
        value
      }
    }
    pool {
      ...PoolFragment
    }
    spentAt {
      format(layout: "2006-01-02T15:04:05-0700")
    }
    spentReason
    spentTxIn {
      index
      txHash
    }
    txIn {
      index
      txHash
    }
  }
`;
export const PoolInfoFragmentFragmentDoc = gql `
  fragment PoolInfoFragment on Pool {
    tvl
    name
    priceUSD
  }
`;
export const ExtendPoolFragmentFragmentDoc = gql `
  fragment ExtendPoolFragment on Pool {
    ...PoolFragment
    ...PoolInfoFragment
  }
`;
export const GetOperationsHistoryDocument = gql `
  query getOperationsHistory($address: String!, $pageSize: Int, $token: String) {
    opHistory(address: $address, pageSize: $pageSize, token: $token) {
      ops {
        ...OperationFragment
      }
      token
    }
  }
  ${OperationFragmentFragmentDoc}
  ${OpFragmentFragmentDoc}
  ${PoolFragmentFragmentDoc}
  ${AssetFragmentFragmentDoc}
`;
export const GetPopularPoolsDocument = gql `
  query getPopularPools($pageSize: Int) {
    poolsPopular(pageSize: $pageSize) {
      ...ExtendPoolFragment
    }
  }
  ${ExtendPoolFragmentFragmentDoc}
  ${PoolFragmentFragmentDoc}
  ${AssetFragmentFragmentDoc}
  ${PoolInfoFragmentFragmentDoc}
`;
export const SearchPoolsDocument = gql `
  query searchPools($query: String!) {
    pools(query: $query) {
      ...PoolFragment
    }
  }
  ${PoolFragmentFragmentDoc}
  ${AssetFragmentFragmentDoc}
`;
export const GetAssetsByIdsDocument = gql `
  query getAssetsByIds($ids: [String!]!) {
    assets(ids: $ids) {
      ...AssetFragment
    }
  }
  ${AssetFragmentFragmentDoc}
`;
export const GetPoolQuantityByIdentDocument = gql `
  query getPoolQuantityByIdent($ident: String!) {
    poolByIdent(ident: $ident) {
      quantityB
      quantityLP
      assetB {
        decimals
      }
      assetLP {
        policyId
        assetName
      }
    }
  }
`;
const defaultWrapper = (action, _operationName, _operationType) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getOperationsHistory(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetOperationsHistoryDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getOperationsHistory", "query");
        },
        getPopularPools(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetPopularPoolsDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getPopularPools", "query");
        },
        searchPools(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SearchPoolsDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "searchPools", "query");
        },
        getAssetsByIds(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetAssetsByIdsDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getAssetsByIds", "query");
        },
        getPoolQuantityByIdent(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetPoolQuantityByIdentDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getPoolQuantityByIdent", "query");
        },
    };
}
//# sourceMappingURL=stats2.sdk.js.map